module.exports = __webpack_public_path__ + "img/pc_img.5db860e6.png";